import { formatCurrency } from "@/utils/currencyUtils";

interface LoanTermInfoProps {
  interest_rate: number | null;
  term_months: number | null;
  total_amount: number | null;
}

export const LoanTermInfo = ({
  interest_rate,
  term_months,
  total_amount
}: LoanTermInfoProps) => {
  return (
    <div className="grid gap-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <p className="text-sm font-medium text-muted-foreground">Interest Rate</p>
          <p className="text-sm mt-1">
            {interest_rate ? `${interest_rate}%` : 'N/A'}
          </p>
        </div>
        <div>
          <p className="text-sm font-medium text-muted-foreground">Term</p>
          <p className="text-sm mt-1">
            {term_months ? `${term_months} months` : 'N/A'}
          </p>
        </div>
      </div>
      <div>
        <p className="text-sm font-medium text-muted-foreground">Total Repayment</p>
        <p className="text-sm mt-1">
          {total_amount ? formatCurrency(total_amount, "GHS") : 'N/A'}
        </p>
      </div>
    </div>
  );
};